// src/utils/constants.js

export const FILTER_TYPES = {
  SYMMETRY: 'symmetry',
  MANTRA: 'mantra',
  BALANCE: 'balance',
  UPPER_TRIGRAM: 'upperTrigram',
  LOWER_TRIGRAM: 'lowerTrigram',
  TRANSITION: 'transition',
  AMINO: 'amino',
  BOTTOM_SIXIANG: 'bottomSixiang',
  MIDDLE_SIXIANG: 'middleSixiang',
  TOP_SIXIANG: 'topSixiang'
};

export const APP_VIEWS = {
  HOME: 'home',
  GRID: 'grid',
  SEQUENCES: 'sequences',
  SEFIROT: 'sefirot'
};

export const TAB_NAMES = {
  READER: 'reader',
  INSPECTOR: 'inspector',
  FILTERS: 'filters',
  MANAGER: 'manager'
};

export const SEQUENCE_TYPES = {
  BINARY: 'binary',
  GRAY: 'gray',
  KINGWEN: 'kingwen',
  BAGUA: 'bagua',
  EARLY: 'early',
  LATER: 'later'
};

export const LOCAL_STORAGE_KEYS = {
  DARK_MODE: 'yijing_dark_mode',
  EDIT_STAGE: 'yijing_edit_stage',
  CUSTOM_SEQUENCES: 'yijing_custom_sequences'
};
